
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class SummaryViewGrid extends SiteEntityGrid<SummaryViewRow, any> {
        protected getColumnsKey() { return 'Rebalancer.SummaryView'; }
        protected getDialogType() { return SummaryViewDialog; }
        protected getIdProperty() { return SummaryViewRow.idProperty; }
        protected getLocalTextPrefix() { return SummaryViewRow.localTextPrefix; }
        protected getService() { return SummaryViewService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}